import InApp from "detect-inapp";
import { getMobileOperatingSystem } from "../utils/DetectMobileType";
import {
  api,
  formDataApi,
  giftApi,
  repeatApi,
  transferApi,
  transferRepeatApi,
  userApi,
} from "./baseApi";
import CryptoJS, { MD5 } from "crypto-js";
import { customCryptoPassword } from "../utils/customCryptoPassword";

const device = getMobileOperatingSystem();
// const inapp = new InApp(
//   navigator.userAgent || navigator.vendor || window.opera
// );
// const ISAPP = inapp.isInApp
//   ? "APP"
//   : window.matchMedia("(display-mode: standalone)").matches
//   ? "PWA"
//   : "WEB";
// const DEVICE = `${device} (${ISAPP})`; //設備檢測

export const actionSignIn = ({ account, passwd } = {}) => {
  return api.post("/login", {
    memId: account,
    Password: CryptoJS.MD5(passwd).toString(),
    country: "TW",
  });
};

export const actionLogout = () => {
  return api.post("logout");
};

export const actionSignUp = ({
  memId,
  passwd,
  blank_name,
  messageapp, //通訊軟體
  unlimit_code, //無現代推廣碼
  email,
  mobile,
  auth_num, //驗證碼
  invite, //推廣碼
} = {}) => {
  return api.post("/siginUp", {
    memId: memId,
    passwd: customCryptoPassword(passwd),
    blank_name: blank_name, //真實姓名
    messageapp: messageapp,
    unlimit_code: unlimit_code,
    email: email,
    mobile: mobile,
    auth_num: auth_num,
    invite: invite,
  });
};

export const actionGoogleLogin = ({
  user_id, //req
  emailAddress, //req
  unlimit_code, //無現代推廣碼
  invite, //推廣碼
  s_auth, //判斷是不是從此網域使用google
  r_auth, //判斷是不是從此網域使用google
} = {}) => {
  return repeatApi.post("/goGoogle", {
    user_id: user_id,
    emailAddresses: emailAddress,
    unlimit_code: unlimit_code,
    invite: invite,
    s_auth: s_auth,
    r_auth: r_auth,
  });
};

export const actionTelegramLogin = ({
  telegramId, //req
  hash, //req
  first_name, //req
  last_name, //req
  unlimit_code, //無現代推廣碼
  invite, //推廣碼
  s_auth, //判斷是不是從此網域使用google
  r_auth, //判斷是不是從此網域使用google
} = {}) => {
  return repeatApi.post("/goTelegram", {
    id: telegramId,
    hash: hash,
    last_name: last_name,
    first_name: first_name,
    unlimit_code: unlimit_code,
    invite: invite,
    s_auth: s_auth,
    r_auth: r_auth,
  });
};

export const resetPassword = ({ old_pwd, new_pwd } = {}) => {
  return api.post("/passwordReset", {
    old_pwd: customCryptoPassword(old_pwd),
    new_pwd: customCryptoPassword(new_pwd),
  });
};

export const resetWithdrawPassword = ({ old_pwd, new_pwd } = {}) => {
  //重設交易密碼
  return api.post("/reset/withdrawPwd", {
    old_pwd: customCryptoPassword(old_pwd),
    new_pwd: customCryptoPassword(new_pwd),
  });
};

export const depositPayment = ({
  amount,
  pay_type,
  pay_way,
  channel_code,
} = {}) => {
  return api.post("/deposit", {
    amount: amount,
    pay_type: pay_type,
    pay_way: pay_way,
    channel_code: channel_code,
  });
};

export const depositVipPayment = ({
  bank_uid,
  amount,
  bank_number_last5,
} = {}) => {
  return api.post("vip/deposit", {
    bank_uid: bank_uid,
    amount: amount,
    bank_number_last5: bank_number_last5,
  });
};

export const bindCardInformation = ({ formData } = {}) => {
  return formDataApi.post("/bindBankAccount", formData);
};

export const bankWithdraw = ({
  bank_name,
  bank_branch,
  bank_account,
  bank_card_number,
  secret_pwd,
  amounts,
} = {}) => {
  return api.post("/withdraw", {
    amount: amounts,
    bank_card_number: bank_card_number,
    bank_info: `${bank_name}/${bank_branch}/${bank_account}`,
    secret_pwd: customCryptoPassword(secret_pwd),
  });
};

export const transferWalletToGame = ({
  //转账模式平台,主钱包转至游戏钱包
  platformUid,
  platformType,
  depositAmount,
} = {}) => {
  return transferApi.post("/transfersModeMainToGame", {
    platformUid: platformUid,
    platformType: platformType,
    amount: Number(depositAmount),
  });
};

export const actionUseGift = ({ good_uid } = {}) => {
  return giftApi.post("/use", {
    good_uid: good_uid,
  });
};

export const transferGameToWallet = ({
  //转账模式平台,游戏钱包转至主钱包
  platformUid,
  platformType,
  withdrawAmount,
}) => {
  return transferApi.post("/transfersModeGameToMain", {
    platformUid: platformUid,
    platformType: platformType,
    amount: Number(withdrawAmount),
  });
};

export const transferRepeatGameToWallet = ({
  //转账模式平台,游戏钱包转至主钱包
  platformUid,
  platformType,
  withdrawAmount,
}) => {
  return transferRepeatApi.post("/transfersModeGameToMain", {
    platformUid: platformUid,
    platformType: platformType,
    amount: Number(withdrawAmount),
  });
};

export const singleWalletToGame = ({
  //單一錢包模式,主钱包转至游戏钱包
  platformUid,
  platformType,
  depositAmount,
}) => {
  return transferApi.post("/singleModeMainToGame", {
    platformUid: platformUid,
    platformType: platformType,
    amount: Number(depositAmount),
  });
};

export const singleGameToWallet = ({
  //單一錢包模式,游戏钱包转至主钱包
  platformUid,
  platformType,
  depositAmount,
}) => {
  return transferApi.post("/singleModeGameToMain", {
    platformUid: platformUid,
    platformType: platformType,
    amount: Number(depositAmount),
  });
};

export const withdrawCommission = () => {
  return api.post("/withdraw/commission");
}; //取傭金

export const enterPlayGame = ({
  gameUid,
  lang = "viet",
  isMobile = 2,
  gameCode,
} = {}) => {
  return api.post("/game/go", {
    gameUid: gameUid,
    lang: lang,
    is_mobile: isMobile,
    gameCode: gameCode,
  });
};

export const readInbox = ({ inboxUid } = {}) => {
  return api.post(`/letter/read/${inboxUid}`);
};

//註冊驗證機器人
export const verifiedRobotBoy = (recaptchaResponse) => {
  return api.post("/reCaptcha", { "g-recaptcha-response": recaptchaResponse });
};

export const cloudFlareverifiedRobotBoy = ({ cloudFlareToken }) => {
  return api.post("/siteverify", {
    "cf-turnstile-response": cloudFlareToken,
  });
};

//領取禮包
export const receiveGift = ({ good_uid } = {}) => {
  return giftApi.post("/receive", {
    good_uid: good_uid,
  });
};

export const testSocket = () => {
  return userApi.post("/testForBalanceDetect");
};
